export enum SupervisoryAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  PATIENT_OVERVIEW = 'patient-overview',
  SUPERVISORY_REVIEW = 'supervisory-review',
  FINAL_STEPS = 'final-steps'
}

export const SupervisoryAssessmentAnchors = [
  {
    key: SupervisoryAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: SupervisoryAssessmentSections.PATIENT_OVERVIEW,
    href: '#patient-overview',
    title: 'Patient Overview'
  },
  {
    key: SupervisoryAssessmentSections.SUPERVISORY_REVIEW,
    href: '#supervisory-review',
    title: 'Supervisory Review'
  },
  {
    key: SupervisoryAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]
